import React, { useState, useEffect } from 'react';

const ImageCarousel = ({ images, alt, className }) => {
  const [current, setCurrent] = useState(0);
  const imgs = images && images.length > 0 ? images : [];

  useEffect(() => {
    if (imgs.length <= 1) return;
    const timer = setInterval(() => {
      setCurrent(prev => (prev + 1) % imgs.length);
    }, 3000);
    return () => clearInterval(timer);
  }, [imgs.length]);

  if (imgs.length === 0) return null;

  return (
    <div className={`relative overflow-hidden ${className || ''}`} data-testid="image-carousel">
      {imgs.map((img, idx) => (
        <img
          key={idx}
          src={img}
          alt={`${alt || 'Image'} ${idx + 1}`}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ease-in-out ${idx === current ? 'opacity-100' : 'opacity-0'}`}
        />
      ))}
      {imgs.length > 1 && (
        <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1.5 z-10">
          {imgs.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setCurrent(idx)}
              className={`w-1.5 h-1.5 rounded-full transition-all ${idx === current ? 'bg-white w-3' : 'bg-white/50'}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default ImageCarousel;
